import * as React from "react";
import { useTranslation } from "react-i18next";

const fields =  {

        config: { columns: 1 },
        fields: [
            {
                name: "fileName",
                label:  "fileTable.nameFile",
                column: 1,
                mandatory: true,
            }, {
                name: "fileDescription",
                label: "fileTable.fileDescription",
                type: "textarea",
                column: 1,
            }

        ]


    };

export default fields;